import React from "react";
import "./Myproject.css";



export const Myproject = () => {
    return (
        <div className="Myproject">
            <div className="Myproject_assign">Assigned</div>
            <div className="Myproject_title">Create new logos for any 5 existing brands</div>
            <div className="Myproject_date">Created On: 5th Nov</div>
            <div className="Myproject_due">Due time: 11pm on 15th Nov</div>
        </div>
    );
}